import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { layoutStore } from 'shared/layout'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useBillingViewContext } from 'pages/settings/pages/billing/context/billingViewContext'
import { UpgradeFirstPage } from 'pages/settings/pages/billing/pages/upgrade/ui/UpgradeFirstPage/UpgradeFirstPage'
import { UpgradeSecondPage } from 'pages/settings/pages/billing/pages/upgrade/ui/UpgradeSecondPage/UpgradeSecondPage'
import { BreakpointsUpgradeEnum } from 'pages/settings/pages/billing/pages/upgrade/constants/breakpoints'
import {
  ProviderBillingUpgradePage,
  useBillingUpgradePageContext,
} from 'pages/settings/pages/billing/pages/upgrade/context/upgradeContext'
import {
  BillingUpgradePageStore,
  type IUpgradePageLocationState,
} from 'pages/settings/pages/billing/pages/upgrade/store/upgradePageStore'
import styles from './styles.module.scss'

const UpgradePageContent = observer(() => {
  const billingStore = useBillingViewContext()
  const store = useBillingUpgradePageContext()
  const { isFirstStep } = store

  useEffect(() => {
    const initializeStore = async () => {
      await billingStore.init()
      store.init()
    }

    initializeStore()
  }, [store, billingStore])

  useEffect(() => {
    layoutStore.setBreakpoints(BreakpointsUpgradeEnum)

    return () => {
      layoutStore.setDefault()
    }
  }, [])

  return (
    <div className={styles.container}>
      {isFirstStep ? <UpgradeFirstPage /> : <UpgradeSecondPage />}
    </div>
  )
})

export const UpgradePage = observer(() => {
  const entities = useEntitiesContext()
  const location = useLocation()
  const navigate = useNavigate()
  const locationState = location.state as IUpgradePageLocationState | null
  const [upgradeStore] = useState(() => new BillingUpgradePageStore(entities, locationState))

  useEffect(() => {
    if (locationState?.checkOpportunity) {
      navigate(location.pathname, { replace: true, state: {} })
    }
  }, [])

  return (
    <ProviderBillingUpgradePage value={upgradeStore}>
      <UpgradePageContent />
    </ProviderBillingUpgradePage>
  )
})
